export const EMAIL_MESSAGE_FIELDS = {
  subject: 'subject',
  templateName: 'templateName',
  messageBody: 'messageBody',
  customFromName: 'customFromName',
  messageTemplate: 'messageTemplate',
  messageModalities: 'messageModalities',
  formats: 'formats',
  survey: 'survey',
  combined: 'combined',
  okResponse: 'okResponse',
  needHelpResponse: 'needHelpResponse',
  acknowledgeResponse: 'acknowledgeResponse',
  primaryContactInfoOnly: 'primaryContactInfoOnly',
  resendFrequencyDuration: 'resendFrequencyDuration',
  deliveryRanking: 'deliveryRanking',
  deliveryWaitTime: 'deliveryWaitTime',
  defaultDeliveryRanking: 'defaultDeliveryRanking',
  // templateApplied is a workaround to detect when a saved template's data has fully been applied to the delivery modal component. Used for loading state of manage delivery priority button.
  // Using the deliveryRanking field itself was not accurate since it sometimes contains stale data before useEffects finish running.
  templateApplied: 'templateApplied',
};

export const EMAIL_SURVEY_FIELDS = {
  QUESTIONS: 'questions',
  RESPONSE_OPTIONS: 'responseOptions',
  NUMBER: 'number',
  TEXT: 'text',
};

export const MESSAGE_TYPE_VALUES = {
  MESSAGE: 'MESSAGE',
  QUOTA: 'QUOTA',
};

export const MESSAGE_TYPE_FIELD = 'messageType';
export const QUOTA_REQUIRED_RESPONSES_FIELD = 'quotaRequiredResponses';
export const QUOTA_CONFIGURATION = 'quotaConfiguration';
export const QUOTA_CONFIGURATION_FIELD = {
  NEGATIVE_RESPONSE: 'quotaNegativeResponse',
  NUMBER: 'number',
  POSITIVE_RESPONSE: 'quotaPositiveResponse',
  QUESTION: 'question',
  QUESTIONS: 'questions',
  QUOTA_REQUIRED_RESPONSES: 'quotaRequiredResponses',
  RESPONSE_OPTIONS: 'responseOptions',
  TEXT: 'text',
};

export const TIERS = 'tiers';
export const TIER_FIELD = {
  MANAGED_RECIPIENTS: 'managedRecipients',
  // Template-saved recipients a user without MANAGE_MASS_NOTIF_TEMPLATES can't remove.
  LOCKED_RECIPIENTS: 'lockedRecipients',
  STOP_CONTACTING_AFTER: 'stopContactingAfter',
};
export const TIER_STOP_CONTACTING_AFTER_DEFAULT = 'PT1H';
export const MAX_TIERS = 10;
export const TIER_DURATION_CONSTRAINTS = {
  hours: {min: 1, max: 48},
  minutes: {min: 5, max: 2880},
};

export const MESSAGE_MODALITIES = {
  EMAIL_FORMAT: 'emailFormat',
  PUSH_FORMAT: 'pushFormat',
  SMS_FORMAT: 'smsFormat',
  TTS_FORMAT: 'ttsFormat',
  DESKTOP_FORMAT: 'desktopAlertFormat',
};

export const MESSAGE_MODALITY_LABELS = {
  EMAIL_LABELS: 'selectedEmailLabels',
  PUSH_LABELS: 'selectedPushLabels',
  SMS_LABELS: 'selectedSmsLabels',
  TTS_LABELS: 'selectedTtsLabels',
  DESKTOP_LABELS: 'selectedDesktopLabels',
};

export const ORGANIZATION_ID = 'organizationId';
export const SHOULD_TRANSLATE = 'autoTranslationDisabled';
export const DELIVERY_RULES = 'deliveryRules';
export const DELIVERY_PRIORITY_RULE = 'deliveryPriorityRule';
export const MESSAGE_LANGUAGE = 'messageLanguage';
export const ATTACHMENT_IDS = 'attachmentIds';

export const MODALITY_TO_LABELS_MAP = {
  [MESSAGE_MODALITIES.EMAIL_FORMAT]: MESSAGE_MODALITY_LABELS.EMAIL_LABELS,
  [MESSAGE_MODALITIES.PUSH_FORMAT]: MESSAGE_MODALITY_LABELS.PUSH_LABELS,
  [MESSAGE_MODALITIES.SMS_FORMAT]: MESSAGE_MODALITY_LABELS.SMS_LABELS,
  [MESSAGE_MODALITIES.TTS_FORMAT]: MESSAGE_MODALITY_LABELS.TTS_LABELS,
  [MESSAGE_MODALITIES.DESKTOP_FORMAT]: MESSAGE_MODALITY_LABELS.DESKTOP_LABELS,
};

export const MAX_CHAR_COUNT = {
  [MESSAGE_MODALITIES.EMAIL_FORMAT]: 8000000,
  [MESSAGE_MODALITIES.PUSH_FORMAT]: 3500,
  [MESSAGE_MODALITIES.SMS_FORMAT]: 1000,
  [MESSAGE_MODALITIES.TTS_FORMAT]: 2500,
  [MESSAGE_MODALITIES.DESKTOP_FORMAT]: 500,
};

//maximum number of characters in one SMS message
export const MAX_SMS_LENGTH = 160;

export const REQUIRE_STATUS_CONFIRMATION = 'statusConfirmationOptions';
export const REQUIRE_STATUS_CONFIRMATION_CHECKED = 'statusConfirmationOptionsChecked';
export const RESPONSE_OPTIONS = 'responseOptions';
export const RESEND_FREQUENCY = 'resendFrequency';
export const RESPONSE_OPTIONS_VALUE = [
  {
    number: 1,
    text: 'OK',
  },
  {
    number: 2,
    text: 'Need Help',
  },
];

export const SINGLE_RESPONSE_OPTIONS_VALUE = [
  {
    number: 1,
    text: 'Acknowledge',
  },
];

export const FREQUENCY_TIME_RANGE = {H: {min: 1, max: 24}, M: {min: 30, max: 60}};

export const CONFIG = 'config';
export const FORMATS = 'formats';
export const COMBINED = 'combined';
export const SURVEY = 'survey';
export const TYPE = 'type';
export const LANGUAGE = 'language';
export const SCHEDULE = 'schedule';
export const CONFERENCE_BRIDGE = 'conferenceBridge';
export const CONFERENCE_BRIDGE_CHECKED = 'conferenceBridgeChecked';
export const INTERNAL_CONFERENCE_BRIDGE_CHECKED = 'internalConferenceBridgeChecked';
export const INTERNAL_CONFERENCE_BRIDGE_NUMBER = 'internalConferenceBridgeNumber';
export const INTERNAL_CONFERENCE_BRIDGE_FIELD = 'internalConferenceBridge';
export const PHONE_NUMBER = 'phoneNumber';
export const ACCESS_CODE = 'accessCode';
export const RECIPIENT_COUNT = 'recipientCount';
export const MESSAGE_RECIPIENT_SOURCES = 'messageRecipientSources';
export const MANAGED_RECIPIENTS = 'managedRecipients';
export const FORMATTED_REQUIRED_RECIPIENTS = 'formattedRequiredRecipients';
export const TEMPORARY_MANAGED_RECIPIENTS = 'temporaryManagedRecipients';
export const TEMPORARY_ADDITIONAL_RECIPIENTS = 'temporaryAdditionalRecipients';
export const PERSON_IDS = 'personIds';
export const PERSON_GROUP_IDS = 'personGroupIds';
export const SITE_IDS = 'siteIds';
export const SAVED_SEARCH_IDS = 'savedSearchIds';
export const INCLUDED_PERSON_IDS = 'includedPersonIds';
export const REQUIRED_RECIPIENTS = 'requiredRecipients';
export const OPTIONAL_RECIPIENTS = 'optionalRecipients';
export const MESSAGE_TEMPLATE_ID = 'messageTemplateId';
export const SCHEDULED_MESSAGE_ID = 'scheduledMessageId';
export const VIEW_RECIPIENTS = 'viewRecipients';
export const TEMPLATE_RECIPIENTS = 'templateRecipients';
export const TIER_MANAGED_RECIPIENTS = 'tierManagedRecipients';
export const MANAGE_RECIPIENTS = 'manageRecipients';
export const ADDITIONAL_RECIPIENTS = 'additionalRecipients';
export const OPTIONAL_GROUPS = 'optionalGroups';
export const ADDITIONAL_GROUPS = 'additionalGroups';
export const OPTIONAL_SAVED_SEARCHES = 'optionalSavedSearches';
export const OPTIONAL_SITES = 'optionalSites';
export const ADDITIONAL_SAVED_SEARCHES = 'additionalSavedSearches';
export const RECIPIENTS = 'recipients';
export const GROUPS = 'groups';
export const SAVED_SEARCHES = 'savedSearches';
export const SITES = 'sites';
export const PRIMARY_CONTACT_INFO_ONLY = 'primaryContactInfoOnly';
export const STANDARD_VARIABLES = 'standardVariables';

export const STATUS_CONFIRMATION_TYPE = {
  OK: 'okCount',
  NEED_HELP: 'needHelpCount',
  NO_RESPONSE: 'noResponseCount',
  UNDELIVERABLE: 'undeliverableCount',
};

export const MESSAGE_TEMPLATE_FIELDS = {
  TEMPLATE: 'template',
  NAME: 'name',
  AUDIT_INFO: 'auditInfo',
  UPDATED_AT: 'updatedAt',
  UPDATED_BY: 'updatedBy',
  USERNAME: 'username',
  INHERITED: 'inherited',
  DISABLED: 'disabled',
  ID: 'id',
  DESCRIPTION: 'description',
  RECIPIENT_OPTION_SELECT: 'recipientOptionSelect',
};

export const SCHEDULE_TYPE = {
  SEND_LATER: 'sendLater',
  SET_SCHEDULE: 'setSchedule',
};

export const REMOTE_FILE_TYPE = {
  MESSAGE_ATTACHMENT: 'MESSAGE_ATTACHMENT',
  SCHEDULED_MESSAGE_ATTACHMENT: 'SCHEDULED_MESSAGE_ATTACHMENT',
  MESSAGE_TEMPLATE_ATTACHMENT: 'MESSAGE_TEMPLATE_ATTACHMENT',
};

export const REMOTE_FILE_UPLOAD_STATUS = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const SENDER_RECIPIENT_OPTIONS = {
  CAN_ADD_RECIPIENTS: 'CAN_ADD_RECIPIENTS',
  CAN_ADD_SPECIFIC_RECIPIENTS: 'CAN_ADD_SPECIFIC_RECIPIENTS',
  CANNOT_ADD_RECIPIENTS: 'CANNOT_ADD_RECIPIENTS',
};

export const DRAWER_CONTEXT = {
  TEMPLATE: 'TEMPLATE',
  COMPOSE_MESSAGE: 'COMPOSE_MESSAGE',
};

export const RECIPIENT_TYPE_ID_KEYS = {
  PERSON_IDS: PERSON_IDS,
  PERSON_GROUP_IDS: PERSON_GROUP_IDS,
  SITE_IDS: SITE_IDS,
  SAVED_SEARCH_IDS: SAVED_SEARCH_IDS,
};

export const DESKTOP_ALERT_PROPERTIES = {
  SIZE: 'alertSize',
  COLOR: 'alertColor',
  ALERT_SOUND: 'alertSound',
};

export const DESKTOP_ALERT_SIZE_OPTIONS = [
  {value: 'COMPACT', messageKey: 'desktopAlertSizeCompact'},
  {value: 'EXPANDED', messageKey: 'desktopAlertSizeExpanded'},
  {value: 'FULL_SCREEN', messageKey: 'desktopAlertSizeFullScreen'},
];

export const DESKTOP_ALERT_COLOR_OPTIONS = [
  {value: 'GREEN', messageKey: 'desktopAlertColorGreen'},
  {value: 'YELLOW', messageKey: 'desktopAlertColorYellow'},
  {value: 'RED', messageKey: 'desktopAlertColorRed'},
];

export const DESKTOP_ALERT_SOUND_OPTIONS = [
  {value: 'RING', messageKey: 'desktopAlertSoundRing'},
  {value: 'BEEP', messageKey: 'desktopAlertSoundBeep'},
  {value: 'ALARM', messageKey: 'desktopAlertSoundAlarm'},
  {value: 'NO_SOUND', messageKey: 'desktopAlertSoundNoSound'},
];

// Posting Options form field names
export const POST_MESSAGE_CHECKBOX = 'postMessageCheckbox';
export const POST_INTEGRATIONS = 'integrations';
export const POST_IS_COMBINED = 'isPostCombined';
export const BULLETIN_BOARD_MESSAGE = 'bulletinBoardMessage';
export const SLACK_INTEGRATION_CONFIG_ID = 'slackIntegrationConfigId';
export const TEAMS_INTEGRATION_CONFIG_ID = 'teamsIntegrationConfigId';
export const INTEGRATION_MESSAGES = 'integrationMessages';

// Response Driven Messaging Form Fields
export const MESSAGE_ACTIONS = 'actions';
export const MESSAGE_ACTION_TYPE = {
  SEND_MESSAGE_FROM_TEMPLATE: 'SEND_MESSAGE_FROM_TEMPLATE',
};
export const MESSAGE_ACTION_TRIGGER_TYPE = {
  STATUS_CONFIRMATION_RESPONSE: 'STATUS_CONFIRMATION_RESPONSE',
};
export const RESPONSE_OPTION_UNIQUE_IDS = ['response-option-1', 'response-option-2', 'response-option-3'];
// UI-only form field name for each response option's template dropdown (see useResponseTemplateMenu)
export const getResponseTemplateFieldName = (uniqueId) => `responseTemplate_${uniqueId}`;
